export const plans = [
    {
        subid: 1,
        title: 'Starter Delux',
        description:
            '{"description":"Beautiful course","features":["Good","1 free course per month"]}',
        cycle: 'Monthly',
        status: 'Active',
        type: 'Individual',
        beneficiarycount: 0,
        amount: 5000,
        classcount: 2,
        coursecount: 1,
    },
    {
        subid: 3,
        title: 'Bronze',
        description:
            '{"description":"Beautiful course","features":["Good","2 free courses per month"]}',
        cycle: 'Monthly',
        status: 'Active',
        type: 'Business',
        beneficiarycount: 2,
        amount: 15000,
        classcount: 1,
        coursecount: 1,
    },
    {
        subid: 5,
        title: 'Premium',
        description:
            '{"description":"Beautiful course","features":["Good","5 free courses per month"]}',
        cycle: 'Annually',
        status: 'Active',
        type: 'Individual',
        beneficiarycount: 0,
        amount: 2000,
        classcount: 1,
        coursecount: 1,
    },
    {
        subid: 7,
        title: 'Business Premium',
        description:
            '{"description":"Beautiful course","features":["Good","20 free courses per month"]}',
        cycle: 'Annually',
        status: 'Active',
        type: 'Business',
        beneficiarycount: 5,
        amount: 30000,
        classcount: 4,
        coursecount: 3,
    },
]
